import { LOCATION_STATE } from './constants'

export const getLocation = state => state[LOCATION_STATE].data || {}
